// src/pages/Subpage_103.jsx
import React, { useState, useRef } from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";

import TabsBase from "../../components/reusable/Navigation/TabsBase";
import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import ToolbarHeadSubpage from "../../components/framepart/SubpageLayout/ToolbarHeadSubpage";
import DropdownMulti from "../../components/reusable/Forms/DropdownMulti";
import DropdownList from "../../components/reusable/Forms/DropdownList";
import Button from "../../components/reusable/Forms/Button";
import TextFilter from "../../components/reusable/Forms/TextFilter";
import Switch from "../../components/reusable/Forms/Switch";



import BIMTreeGrid from "../../components/advanced/Datagrid/DatagridTree";
import Papa from "papaparse";

import StructureComposer from "../../components/advanced/StructureComposer/StructureComposer";
/* ============================================================
   OPTIONS GÉNÉRIQUES (Dropdown de la toolbar)
============================================================ */
const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];

/* ============================================================
   FACTORISATION — Styles communs aux containers
============================================================ */
const baseLeftZoneStyle = {
  flex: 3,
  minWidth: 700,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  background: theme.colors.background.surface,
  border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
  flexShrink: 0,
};

const baseRightZoneStyle = {
  flex: 1,
  minWidth: 350,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  background: theme.colors.background.surface,
  border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
  boxSizing: "border-box",
  flexShrink: 0,
};

/* ============================================================
   Helpers CSV → arbre et arbre → CSV
============================================================ */

// Construit un arbre à partir de lignes CSV { code, description }
const buildTreeFromCSV = (csvData) => {
  const tree = [];
  const nodesByCode = {};

  csvData.forEach((row) => {
    const { code, description } = row;
    if (!code) return;

    const level = code.length;
    if (level > 5) return; // Limite : 5 niveaux

    const parentCode = code.slice(0, -1);
    const node = { code, description, children: [] };

    nodesByCode[code] = node;

    if (parentCode && nodesByCode[parentCode]) {
      nodesByCode[parentCode].children.push(node);
    } else {
      tree.push(node);
    }
  });

  return tree;
};

// Aplati l’arbre en lignes { code, description, ifc } pour export CSV
const flattenTreeToRows = (nodes, acc = []) => {
  nodes.forEach((n) => {
    acc.push({
      code: n.code,
      description: n.description,
      ifc: n.ifc || "",
    });
    if (n.children && n.children.length > 0) {
      flattenTreeToRows(n.children, acc);
    }
  });
  return acc;
};

/* ============================================================
   StructurComposer constantes
============================================================ */
const initialData = {entities: {},rootIds: [],};

  const handleSave = (payload) => {
    console.log("Payload à envoyer au backend :", payload);
    // ici appel API .NET
  };




/* ============================================================
   PAGE
============================================================ */
const Subpage_103 = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [switchOn, setSwitchOn] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCategories, setSelectedCategories] = useState([]);

  // Input fichier caché pour l’import CSV
  const fileInputRef = useRef(null);

  /* ============================================================
     Données de démo pour le BIMTreeGrid (Tab B / Zone B1)
  ============================================================ */
  const initialBIMData = [
    {
      code: "0",
      description: "ELEMENTS GENERIQUES",
      children: [
        {
          code: "01",
          description: "Murs génériques",
          children: [
            { code: "011", description: "Mur de fondation, générique" },
            { code: "012", description: "Mur sur extérieur/sur site, générique" },
            { code: "013", description: "Mur d'enveloppe, générique" },
          ],
        },
        {
          code: "02",
          description: "Planchers et dalles génériques",
          children: [
            { code: "021", description: "Radier de fondation, générique" },
            { code: "022", description: "Dalle de sol, générique" },
          ],
        },
      ],
    },
    {
      code: "1",
      description: "FONDATIONS ET SITE",
      children: [
        { code: "10", description: "Élément d’infrastructure" },
        { code: "11", description: "Élément de site" },
      ],
    },
  ];

  const [bimData, setBimData] = useState(initialBIMData);

  /* ============================================================
     Actions Datagrid (modifier / supprimer)
  ============================================================ */
  const handleModifyItem = (item) => {
    console.log("Modifier :", item);
    // Extension future : ouvrir un panneau / modale d’édition.
  };

  const handleDeleteItem = (item) => {
    console.log("Supprimer :", item);
    // Extension future : confirmation puis mise à jour de bimData.
  };

  /* ============================================================
     Actions Header : Import / Export / Ajouter
  ============================================================ */

  const handleImportClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleCSVUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      delimiter: ";",
      complete: (results) => {
        const csvTree = buildTreeFromCSV(results.data);
        setBimData(csvTree);
      },
    });
  };

  const handleExportClick = () => {
    const rows = flattenTreeToRows(bimData);
    const csv = Papa.unparse(rows, { delimiter: ";" });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "classification_bim.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleAddRootClick = () => {
    setBimData((prev) => [
      ...prev,
      {
        code: `R${prev.length + 1}`,
        description: "Nouveau nœud racine",
        children: [],
      },
    ]);
  };

  /* ============================================================
     ZONE A1 (Tab A)
  ============================================================ */
  const zoneA1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        //title: "Composer",
        content: <div>
          <StructureComposer
      initialData={initialData}
      onSave={handleSave}
    /></div>,
      },
    ],
  };

  /* ============================================================
     ZONE A2 (Tab A)
  ============================================================ */
  const zoneA2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone A2 — Informations",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE B1 (Tab B) — Datagrid BIM
  ============================================================ */
  const zoneB1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        // On garde le titre comme demandé
        title: "Zone B1 — Section principale",
        content: (
          <div style={{ marginTop: 4 }}>
            <BIMTreeGrid
              data={bimData}
              onModify={handleModifyItem}
              onDelete={handleDeleteItem}
            />
          </div>
        ),
      },
    ],
  };

  /* ============================================================
     ZONE B2 (Tab B)
  ============================================================ */
  const zoneB2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone B2 — Informations secondaires",
        content: <div>Texte générique…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE C1 (Tab C)
  ============================================================ */
  const zoneC1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone C1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE C2 (Tab C)
  ============================================================ */
  const zoneC2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone C2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };

  /* ============================================================
     ZONE D1 (Tab D)
  ============================================================ */
  const zoneD1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone D1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE D2 (Tab D)
  ============================================================ */
  const zoneD2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone D2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };
/* ============================================================
     ZONE E1 (Tab E)
  ============================================================ */
  const zoneE1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone E1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE E2 (Tab E)
  ============================================================ */
  const zoneE2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone E2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };

/* ============================================================
     ZONE F1 (Tab f)
  ============================================================ */
  const zoneF1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "Zone F1 — Vue générale",
        content: <div>Aucun élément sélectionné.</div>,
      },
    ],
  };

  /* ============================================================
     ZONE F2 (Tab F)
  ============================================================ */
  const zoneF2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "/assets/icones/container/shield.svg",
        title: "Zone F2 — Paramètres",
        content: <div>Configuration non définie…</div>,
      },
    ],
  };

  /* ============================================================
     TABS
  ============================================================ */
  const TabA = (
    <div style={tabStyle}>
      <ContainerBase {...zoneA1} />
      {/* <ContainerBase {...zoneA2} /> */}
    </div>
  );

  const TabB = (
    <div style={tabStyle}>
      <ContainerBase {...zoneB1} />
      <ContainerBase {...zoneB2} />
    </div>
  );

  const TabC = (
    <div style={tabStyle}>
      <ContainerBase {...zoneC1} />
      <ContainerBase {...zoneC2} />
    </div>
  );

  const TabD = (
    <div style={tabStyle}>
      <ContainerBase {...zoneD1} />
      <ContainerBase {...zoneD2} />
    </div>
  );

  const TabE = (
    <div style={tabStyle}>
      <ContainerBase {...zoneE1} />
      <ContainerBase {...zoneE2} />
    </div>
  );

  const TabF = (
    <div style={tabStyle}>
      <ContainerBase {...zoneF1} />
      <ContainerBase {...zoneF2} />
    </div>
  );

  const tabs = [
    { label: "Map", content: TabA },
    { label: "Lists", content: TabB },
    // { label: "Decomposition", content: TabC },
    { label: "Interfaces", content: TabD },
    // { label: "Attributes", content: TabE },
    // { label: "Links relative", content: TabF },
  ];

  /* ============================================================
     RENDER
  ============================================================ */
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100%",
        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <ToolbarHeadSubpage
  style={{
    padding: 24,
    height: 50,
    minHeight: 50,
    overflow: "visible",
    background: "transparent",
  }}

  /* -----------------------------------------------------------
     ZONE GAUCHE — Boutons
  ----------------------------------------------------------- */
  left={[
    <Button variant="blue" onClick={handleImportClick}>
      Importer CSV
    </Button>,

    <Button variant="blue" onClick={handleExportClick}>
      Exporter CSV
    </Button>,

    <Button variant="blue" onClick={handleAddRootClick}>
      Ajouter racine
    </Button>,
  ]}

  /* -----------------------------------------------------------
     ZONE CENTRALE — Dropdown + Recherche
  ----------------------------------------------------------- */
  center={[
    <DropdownMulti
      label="Catégorie"
      options={demoOptions}
      selectedValues={selectedCategories}
      onChange={setSelectedCategories}
      width={300}
      height={32}
    />,

    <TextFilter
      label="Recherche"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="Tapez un texte..."
      style={{ marginBottom: 0 }}
    />,
  ]}

  /* -----------------------------------------------------------
     ZONE DROITE — Switch
  ----------------------------------------------------------- */
  right={[
    <Switch
      label="Actifs"
      enabled={switchOn}
      onChange={setSwitchOn}
      showText={false}
      size="small"
    />,
  ]}
/>


      {/* Input fichier caché pour Import CSV */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        style={{ display: "none" }}
        onChange={handleCSVUpload}
      />

      <TabsBase tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

/* ============================================================
   STYLE COMMUN TABS
============================================================ */
const tabStyle = {
  display: "flex",
  flexDirection: "row",
  gap: 10,
  padding: 10,
  overflowY: "clip",
  overflowX: "hidden",
  minWidth: "fit-content",
  boxSizing: "border-box",
};

export default Subpage_103;
